import { GQL } from "./GQL"
import { MUTATION_UPDATE_CONTRIBUTION } from "./mutations"

export function updateDocumentStatus(organizationId: string, statusGateway: string) {
  const input = { organizationId, statusGateway }
  return GQL.request<UpdateOnlineContributionConfigurationResponse>(MUTATION_UPDATE_CONTRIBUTION, {
    input,
  })
}
